import React__default, { useState } from 'react';
import classNames from 'classnames';
import styles from './Card.scss.mjs';
import { useScrollOverflow } from '../../../../hooks/useScrollOverflow/useScrollOverflow.mjs';

const SCROLL_POSITION_TOLERANCE = 5;
function Card({
  children
}) {
  const [card, setCardRef] = useState(null);
  const {
    canScrollUp,
    canScrollDown
  } = useScrollOverflow(card, {
    tolerance: SCROLL_POSITION_TOLERANCE
  });
  const cardClassNames = classNames(styles.Card, {
    [styles.topShadow]: canScrollUp,
    [styles.bottomShadow]: canScrollDown
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: cardClassNames,
    ref: setCardRef
  }, children);
}

export { Card };
